// import Cookies from 'js-cookie'

const key = 'remember-agreement'

export function isRememberAgreement() {
  // return Cookies.get(key)

  return localStorage.getItem(key)
}

export function setRememberAgreement() {
  // return Cookies.set(key, true)

  return localStorage.setItem(key, true)
}

export function removeRememberAgreement() {
  // return Cookies.remove(key)

  return localStorage.removeItem(key)
}
